<template>
  <app-modal
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-medium"
    title="確認"
  >
    <template v-slot:body="{ cancel, ok }">
      <!-- BODY -->
      <v-card-text class="pa-4 mb-5">
        <div class="modal-body">
          <div class="font-weight-bold mb-3">
            以下の拠点間のポリシー適用を削除します。よろしいですか？
          </div>
          <br />
          <span class="mx-2"
            >{{ $filter.enumTo(zoneRelationItem.srcZoneType, "zoneType") }}/{{
              zoneRelationItem.srcZoneName
            }}</span
          >
          →
          <span class="mx-2"
            >{{ $filter.enumTo(zoneRelationItem.dstZoneType, "zoneType") }}/{{
              zoneRelationItem.dstZoneName
            }}</span
          >
          <span class="font-weight-bold mx-1">削除</span>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn variant="flat" color="primary" @click="ok">はい</v-btn>
            <v-btn variant="outlined" color="primary" @click="cancel">
              いいえ
            </v-btn>
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { ZoneRelationItem } from "@/apis/ZoneRelationApi";

export default defineComponent({
  name: "InternetType1ZoneRelationDeleteConfirm",
  props: {
    zoneRelationItem: {
      type: Object as PropType<ZoneRelationItem>,
      required: true,
    },
  },
});
</script>
